import {StyleSheet} from "react-native";
import {styleVars} from "../../app-style-vars";

export const styles = StyleSheet.create({
  limitedModeTitleText: {
    fontWeight: '600',
    fontSize: styleVars.rem(1.25),
  },
  limitedModeSubTitleText: {
    fontSize: styleVars.rem(.875),
    fontWeight: '600',
    color: styleVars.boschLightGray,
  },
  orderHeaderWrapper: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  orderNoWrapper: {
    flex: 1,
    maxWidth: '30%',
    borderWidth: 1,
    borderColor: styleVars.boschLightGray
  },
  orderDateWrapper: {
    flex: 1,
    maxWidth: '30%',
    borderWidth: 1,
    borderColor: styleVars.boschLightGray
  },
  orderStatusWrapper: {
    flex: 1,
    maxWidth: '30%',
    borderWidth: 1,
    borderColor: styleVars.boschLightGray
  },
  loadMoreContainer: {
    marginVertical: styleVars.rem(.5),
    paddingVertical: styleVars.rem(.5),
    paddingHorizontal: styleVars.rem(1),
    borderWidth: 1,
    borderColor: styleVars.boschDarkBlue,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadMoreText: {
    color: styleVars.boschDarkBlue
  },
  ordersCountWrapper: {
    paddingVertical: styleVars.rem(.5),
  },
  ordersCountText: {
    fontSize: styleVars.rem(.875),
    fontWeight: '600',
  },
  noResultsContainer: {
    paddingHorizontal: styleVars.rem(.5),
    paddingVertical: styleVars.rem(.5),
  },
  noResultsText: {
    fontSize: styleVars.rem(.875),
    textAlign: 'justify'
  },
  showAllContainer: {
    paddingVertical: styleVars.rem(.5),
    paddingHorizontal: styleVars.rem(.5),
  },
  showAllText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue,
    textAlign: 'right',
  }
});